import { getAxiosInstance } from "../ApiConfig";

async function FetchCurrentYearForcast() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getCurrentYearForecasting`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function forecastCalculation() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/forecastCalculation`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getFutureYearForecasting() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getFutureYearForecasting`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getPastYearForecasting() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getPastYearForecasting`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function avgDealValue() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/avgDealValue`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateForecastValue(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateForecastValue`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function commitForecast(forecastCommitYear, status, userId, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/commitForecast/${forecastCommitYear}/${status}/${userId}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchCurrentYearForcast,
    forecastCalculation,
    avgDealValue,
    getPastYearForecasting,
    getFutureYearForecasting,
    updateForecastValue,
    commitForecast,
}